export default function() {
  /* 表格列头 */
  return [
    { label: "序号", type: "index", width: 80 },
    { label: "ID", prop: "id", width: 80 },
    { label: "名称", prop: "name",  width: 100 },
    { label: "跳转链接", prop: "url" },
    { label: "排序", prop: "sort",width: 100 },
    {
      label: "操作",
      prop: "operation",
      width: 200,
      slots: "operation",
      fixed: "right",
    },
  ];
}
